import type {
  PodcastRssPreviewInfo,
  PodcastRssSubmitResult,
  PodcastRssSubmitView,
} from './types';

const MOCK_EXISTING_RESOURCE = {
  id: 'mock-resource-id',
  cover: '',
  name: 'demo-podcast',
  title: '示例播客合集',
  version: '1.0.0',
  policy: ['免费策略'],
  type: ['音频', '播客', '连载播客'],
  status: 1 as const,
  updateDate: '2026-01-01',
  username: 'creator',
  useAvatar: '',
  isChoice: false,
  collection: {
    status: 'unFinish' as const,
    count: 128,
  },
};

export const PODCAST_RSS_SUBMIT_MOCK_EXISTING_RESOURCE = MOCK_EXISTING_RESOURCE;

const DEFAULT_PREVIEW: PodcastRssPreviewInfo = {
  title: '播客节目名称',
  cover: '',
  author: '主播名称',
  episodeCount: 23,
  maskedEmail: '_pod***@gmail.com',
};

export function resolveMockPodcastRssSubmitResult(url: string): PodcastRssSubmitResult {
  const value = url.trim().toLowerCase();
  if (!value) {
    return { view: 'error_invalid' };
  }

  const viewMatchers: { keyword: string; view: PodcastRssSubmitView }[] = [
    { keyword: 'invalid', view: 'error_invalid' },
    { keyword: 'noemail', view: 'error_noemail' },
    { keyword: 'exists-self', view: 'error_alreadyexists_self' },
    { keyword: 'exists-other', view: 'error_alreadyexists_other' },
  ];

  for (const matcher of viewMatchers) {
    if (value.includes(matcher.keyword)) {
      const isAlreadyExists =
        matcher.view === 'error_alreadyexists_self' ||
        matcher.view === 'error_alreadyexists_other';
      return {
        view: matcher.view,
        podcast: isAlreadyExists ? DEFAULT_PREVIEW : undefined,
        existingResource: isAlreadyExists ? MOCK_EXISTING_RESOURCE : undefined,
      };
    }
  }

  if (value.includes('episodes')) {
    return {
      view: 'preview',
      podcast: {
        ...DEFAULT_PREVIEW,
        episodeCount: 3200,
        matchedItemCount: 3200,
      },
    };
  }

  return {
    view: 'preview',
    podcast: DEFAULT_PREVIEW,
  };
}

export async function mockCheckPodcastRssUrl(rssUrl: string): Promise<PodcastRssSubmitResult> {
  await new Promise((resolve) => {
    setTimeout(resolve, 800);
  });
  return resolveMockPodcastRssSubmitResult(rssUrl);
}

/** @deprecated 使用 mockCheckPodcastRssUrl */
export async function mockSubmitPodcastRssUrl(rssUrl: string): Promise<PodcastRssSubmitResult> {
  return mockCheckPodcastRssUrl(rssUrl);
}
